const SORT_OPTIONS = [
  { key: "abv", label: "ABV" },
  { key: "abq", label: "ABQ" },
  { key: "sales", label: "Sales" },
  { key: "bills", label: "Bills" },
  { key: "quantity", label: "Quantity" },
];

export default function SortControl({ sortKey, setSortKey, order, setOrder, idPrefix }) {
  return (
    <div className="flex flex-wrap items-center gap-2">
      <div className="flex items-center gap-1.5">
        <span className="text-xs font-semibold uppercase tracking-wide text-slate-500">Sort by</span>
        <select
          data-testid={`${idPrefix}-sort-key`}
          value={sortKey}
          onChange={(e) => setSortKey(e.target.value)}
          className="rounded-md border border-slate-300 bg-white px-2.5 py-1.5 text-sm outline-none focus:border-blue-700 focus:ring-2 focus:ring-blue-700"
        >
          {SORT_OPTIONS.map((o) => <option key={o.key} value={o.key}>{o.label}</option>)}
        </select>
      </div>
      <div className="flex items-center gap-1.5">
        <span className="text-xs font-semibold uppercase tracking-wide text-slate-500">Order</span>
        <select
          data-testid={`${idPrefix}-sort-order`}
          value={order}
          onChange={(e) => setOrder(e.target.value)}
          className="rounded-md border border-slate-300 bg-white px-2.5 py-1.5 text-sm outline-none focus:border-blue-700 focus:ring-2 focus:ring-blue-700"
        >
          <option value="desc">Highest → Lowest</option>
          <option value="asc">Lowest → Highest</option>
        </select>
      </div>
    </div>
  );
}
